import Article from '../records/ArticleRecord';
export function getMasterArticle(article) {
  if (article.values.hs_translated_from_id) {
    const masterLang = Object.keys(article.translations).find(language => article.translations[language].values.hs_id === article.values.hs_translated_from_id);
    if (!masterLang) {
      return article;
    }
    return new Article(article.translations[masterLang]);
  }
  return article;
}